export default {
  title: "Benef Pref"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5007: { text: "Ocurrió un error en el catálogo de Benef Pref" }
    , WS5007: { text: "Ocurrió un error en el catálogo de Benef Pref" }
    , JS5007: { text: "Ocurrió un error en el catálogo de Benef Pref" }
    , CR5007: { text: "Ocurrió un error en el catálogo de Benef Pref" }
    , UK_BenefPref: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/benefpref.js